import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import LinearProgress from '@material-ui/core/LinearProgress';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { PDFDocument } from 'pdf-lib';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { Popup } from "@progress/kendo-react-popup";
import React, { Component } from "react";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import "../../Styles/TenanatDashBoard.scss";
import AddToCart from "../Tenant/AddToCart";
import GenerateReport from "../Tenant/GenerateReport";
import widgetData from "./WidgetConfig.json";
import Dashboard from "./Dashboard";
import DashboardTextNarrative from "./DashboardTextNarrative"
import Checkbox from '@mui/material/Checkbox';

import BarChartContainer from "./BarChart";
import HeatMapChartContainer from "./HeatMapChart";
import LineChartContainer from "./LineChart";
import TrendingLineChart from "./TrendingLineChart";
import BurnDownChartContainer from "./BurnDownChart";
import HeatMapTimeStamp from "./HeatMapTimeStamp";
import PieChartContainer from "./PieChart";
import TileChart from "./TileChart";
import Histogramwidget from "./HistogramWidget";
import DataReportForRisk from "./DataReportForRisk";
import DataReportForAction from "./DataReportForAction";
import RichTextChart from "./RichTextChart";
import SortableWidgetUI from "./SortableWidgetUI";
import { Sortable } from "@progress/kendo-react-sortable";
import DataReportForTasks from "../Tasks/DataReportForTasks";
import DataReportForActivities from "../Tasks/DataReportForActivities";
import TaskKPITileChart from "../TaskKPITileChart";

const theme = createMuiTheme({
  palette: {
     secondary: {
         main: '#009660'
     }
  }
})

export default class DashBoardReports extends Component {
  freezeNameVar = "";
  isTenentAdmin =
    secureLocalStorage.getItem("loggedClient") === "tenant" ? true : false;
  total = 0;
  backGroundReportList = [];
  isReportLoaded = false;
  isSingleReport = false;
  isFirstApiCallCompleted = false;
  disbleAPICall = false;
  pageSizes = [];
  constructor(props) {
    super(props);

    this.openSidebar = this.openSidebar.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    this.state = {
      openWidgetCreatePopup: false,
      ActiveId: null,
      datasource: [],
      widgetTypeList: [],
      lChartWidth: "",
      showPublicDashboards: false,
      showPrivateDashboards: false,
      showPublicViews: false,
      showPrivateViews: false,
      DbId: "",
      OtherDbId: "",
      showDbChartList: "",
      showDbOtherChartList: false,
      WidgetsId: "wg001",
      ActiveViews: null,
      reportDataList: [],
      reportDataListFilterData: [],
      openCreateDashboard: false,
      scope: "0",
      expandWidgetId: [],
      openSiderBar: false,
      riskList: [],
      showRiskDataSet: false,
      showActionDataSet: false,
      showFreezeReportList: false,
      showDashboardList: true,
      showAddToCart: false,
      selectedDashboard: {},
      cartViewDetails: {},
      cartViewType: "",
      value: [],
      userList: [],
      widgetNameLists: [],
      HeatMapConfigDataOpportunity: [],
      HeatMapConfigDataThreat: [],
      dynamicHeatmapProbabilityRange: [],
      editDashBoardData: {},
      dashBoardResponseTemp: [],
      progresspercent: 100,
      count: 0,
      dashBoardbtnFlag: true,
      dashBoardResponse: [],
      openpopup: false,
      openFreezeModelFlagView: false,
      freezeDashBoardId: 0,
      isFreezeDS: false,
      openDeleteFreezeModelFlag: false,
      freezeEditMode: false,
      freezeName: "",
      customFieldsmaster: [],
      //pagination
      skip: 0,
      take: 4,
      buttonCount: 5,
      type: "numeric",
      info: true,
      pageSizes: true,
      previousNext: true,
      responsive: true,
      swapAxisValue: "",
      dashboardScopePriate: true,
      dashboardScopePublic: true,
      selectedReports: [],
      dragFlag: false,
      openDeleteModelFlag: false,
      enablefreezedashborad: false,
      totalReportsCount:0,
      totalLoadedReportsCount:0,
      dashboardLoaded:false,
      emailloader:false
    };
    this.draggingPos = React.createRef();
    this.dragOverPos = React.createRef();
  }

  openAddToCart(data, type) {
    this.setState({
      showAddToCart: true,
      cartViewDetails: data,
      cartViewType: type,
    });
  }
  closeAddToCart() {
    this.setState({ showAddToCart: false });
  }
  openSidebar(val) {
    if (!this.state.openSiderBar) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }
    this.setState({ ...this.state, openSiderBar: !val });
  }
  handleOutsideClick(e) {
    if (this.node.contains(e.target)) {
      return;
    }
    this.openSidebar(this.state.openSiderBar);
  }

  // Drag and Drop - starts
  onDragEnd = (event) => {
    if (event.target.state.isDragging) {
      let reportIdList = [];
      event.newState.map((item) => {
        reportIdList.push(item.widgetId);
      });
      let oldReportIdList = [];
      let reportDataList = this.state.reportDataList.concat(
        this.backGroundReportList
      );
      reportDataList.map((rep) => {
        oldReportIdList.push(rep.widgetId);
      });

      if (reportIdList.toString() === oldReportIdList.toString()) {
        return;
      } else {
        this.setState({
          reportDataList: event.newState,
        });
        setTimeout(() => {
          this.saveReorderReport(event.newState);
        }, 1000);
      }
    }
  };

  saveReorderReport = (data) => {
    try {
      let reportIdList = [];
      data.map((item) => {
        reportIdList.push(item.widgetId);
      });
      let req = {
        ReportId: reportIdList,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        DashBoardId: this.state.DbId,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      setTimeout(() => {
        Api.widgetPersist(req);
      }, 1000);
      //  sortReportsByIds
      let sortOrder = reportIdList;
      this.state.dashBoardResponseTemp.map((dash) => {
        if (this.state.DbId == dash.dashboardId) {
          let sortedVal = dash.widgetCols.sort(function (a, b) {
            return (
              sortOrder.indexOf(a.widgetId) - sortOrder.indexOf(b.widgetId)
            );
          });
          dash["widgetCols"] = sortedVal;
        }
      });
      this.setState({
        ...this.state,
        dashBoardResponse: this.state.dashBoardResponseTemp,
      });
    } catch (err) {
      console.log(err);
    }
  };

  onDragOver = (event) => {
    this.setState({
      reportDataList: event.newState,
    });
  };
  // Drag and Drop - ends

  selectedDBOpenChart = (item) => {
    if (item.dashboardId === this.state.DbId) {
      this.setState({
        ...this.state,
        showDbChartList: !this.state.showDbChartList,
      });
    } else {
      this.setState({ ...this.state, OtherDbId: item.dashboardId });
      if (item.dashboardId === this.state.OtherDbId) {
        this.setState({
          ...this.state,
          showDbOtherChartList: !this.state.showDbOtherChartList,
        });
      }
    }
  };
  selectedWidgets = (wgts) => {
    this.isSingleReport = true;
    var filteredChartData = this.state.reportDataListFilterData.filter(
      (item) => item.widgetId === wgts.widgetId
    );
    if (filteredChartData.length > 0) {
      this.isReportLoaded = false;
      this.setState({
        ...this.state,
        widgetName: wgts.name,
        WidgetsId: wgts.widgetId,
        reportDataList: filteredChartData,
      });
    } else {
      this.setState({
        ...this.state,
        widgetName: wgts.name,
        WidgetsId: wgts.widgetId,
        reportDataList: [],
      });
    }
  };

  viewPublicViews = () => {
    this.setState({
      ...this.state,
      showPublicViews: !this.state.showPublicViews,
    });
  };
  viewPrivateViews = () => {
    this.setState({
      ...this.state,
      showPrivateViews: !this.state.showPrivateViews,
    });
  };

  viewPublicDashboards = () => {
    this.setState({
      ...this.state,
      showPublicDashboards: !this.state.showPublicDashboards,
    });
  };
  viewPrivateDashboards = () => {
    this.setState({
      ...this.state,
      showPrivateDashboards: !this.state.showPrivateDashboards,
    });
  };

  componentDidMount() {
    this.isAuthorizeUse();
  }
  isAuthorizeUse = async () => {
    if (!secureLocalStorage.getItem("authToken")) {
      if (this.props.match.params.id) {
        this.props.history.push({
          pathname: `/tenant/${this.props.match.params.id}`,
        });
      } else {
        this.props.history.push({
          pathname: "/",
        });
      }
    } else {
      this.getuserAddedByTenant();
      await this.getDashboard(true);
      this.getWidgets();
      //this.getDataSource();
      //this.getMitigationViewAxis();
      this.getMatrixColorCodes();
      this.getFrozenDashboard();
      this.getCustomField();
    }
  };

  getCustomField = async () => {
    let res = [];
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getCustomField(request);
      if (response.status === 200) {
        response.customFields.map((item) => {
          item.cfPossibleValues.map((item1) => {
            item1["hashValue"] = this.convertStrToHash(item1.possibleValues);
          });
        });
        this.setState({
          ...this.state,
          customFieldsmaster: [...response.customFields],
        });
      }
    } catch (err) {
      console.error("Exception:", err);
    }
    return res;
  };

  convertStrToHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    hash = Math.abs(hash).toString();
    return hash;
  };
  getMatrixColorCodes = async () => {
    try {
      // var req = {
      //   WorkstreamId: 0,
      // };
      let response = await Api.MatrixColor();
      if (response.status === 200) {
        // normal,opportunity
        let normal_opp = response.matrixColor.find(
          (item) => item.riskType === "opportunity"
        );
        let opp_colorJsonData = JSON.parse(normal_opp.colorJsonData);

        //  normal,threat
        let normal_threat = response.matrixColor.find(
          (item) => item.riskType === "threat"
        );
        let threat_colorJsonData = JSON.parse(normal_threat.colorJsonData);
        this.setState({
          HeatMapConfigDataThreat: threat_colorJsonData,
          HeatMapConfigDataOpportunity: opp_colorJsonData,

          heatMapCount: response.heatmapCount,
          dynamicHeatmapProbabilityRange:
            response.dynamicHeatmapProbabilityRange,
        });
        this.setState({ swapAxisValue: response.isAxisSwap });
      }
    } catch (error) {
      console.error(error);
    }
  };
  GetSingleuser = async () => {
    var request = {
      UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
    };
    let response = await Api.GetSingleuser(request);
    if (response.status === 200) {
      if (response.tenantUsers && response.tenantUsers.length > 0) {
        secureLocalStorage.setItem("role", response.tenantUsers[0].role);
      }
    }
  };

  getuserAddedByTenant = async () => {
    try {
      let response = await Api.getuserAddedByTenant();
      if (response.status === 200) {
        let list = [];
        response.tenantUsers.map((item) => {
          if (item.emailAddress != secureLocalStorage.getItem("setEmail")) {
            list.push({
              userId: item.userId,
              displayName: item.name + " (" + item.emailAddress + ")",
              email: item.emailAddress,
              selected: false,
              isSuperAdmin: item.isSuperAdmin,
              isTenantAdmin: item.isTenantAdmin,
              accessibility: false,
            });
          }
        });
        this.setState({
          ...this.state,
          userList: list,
        });
      } else {
        this.setState({ ...this.state, userList: [] });
      }
    } catch (erro) {
      this.setState({ ...this.state, loader: false, userList: [] });
      console.error(erro);
    }
  };
  createWidgetdOpen = (data) => {
    this.setState({
      ...this.state,
      openWidgetCreatePopup: true,
      dashBoardId: data.dashboardId,
    });
  };
  createWidgetdClose = () => {
    this.setState({
      ...this.state,
      openWidgetCreatePopup: false,
      dashBoardId: 0,
      Name: "",
      WidgetTypeId: "",
      ActiveId: "",
      datasource: "",
      XAxisValue: [],
      YAxisValue: [],
    });
  };

  sortReportsByIds = (widIds, items) => {
    var sortOrder = widIds;
    // items     = [{id: 1}, {id: 2}, {id: 3}, {id: 4}];
    items.sort(function (a, b) {
      return sortOrder.indexOf(a.widgetId) - sortOrder.indexOf(b.widgetId);
    });
    return items;
  };

  asyncReportGeneration = async (
    dashboardId,
    skip,
    take,
    total,
    widIds,
    flag
  ) => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DashBoardId: parseInt(dashboardId),
        skip: skip,
        take: take,
      };
      let response = await Api.getReportsByDashboardID(request);
      if (response.status === 200 && response.chartData) {
        let arr = [...this.state.reportDataList, ...response.chartData];
        let cnt = Number(this.state.count + response.chartData.length);
        let percent = Math.round((cnt / total) * 100);
        let withAccessibility = arr.map((dataItem) =>
          Object.assign(
            {
              // disabled: dataItem.widgetType == "TEXT_WIDGET" ? true : flag,
              disabled: flag,
              editable: false,
            },
            dataItem
          )
        );

        let sortedValue = this.sortReportsByIds(widIds, withAccessibility);
        if (sortedValue) {
          this.setState({
            ...this.state,
            reportDataList: sortedValue,
            reportDataListFilterData: sortedValue,
            DbId: dashboardId,
            progresspercent: percent,
            count: cnt,
            // dashBoardbtnFlag:percent==100?true:false
          });
        }
      } else {
        this.setState({
          ...this.state,
          DbId: dashboardId,
          // progresspercent: 0,
        });
      }
      // //console.clear();
    } catch (error) {
      this.setState({
        ...this.state,
        loader: false,
      });
      console.error(error);
    }
  };

  getReportsByDashboardID = async (dashboardId) => {
    this.setState({
      ...this.state,
      loader: false,
      reportDataList: [],
      count: 0,
      progresspercent: 1,
      dashBoardbtnFlag: false,
    });
    let dashboardList = this.state.dashBoardResponseTemp.find(
      (item) => item.dashboardId == dashboardId
    );
    if (
      dashboardList &&
      dashboardList.widgetCols &&
      dashboardList.widgetCols.length > 0
    ) {
      let n = dashboardList.widgetCols.length;
      let widIds = [];
      dashboardList.widgetCols.map((wid) => {
        widIds.push(wid.widgetId);
      });

      const userId = parseInt(secureLocalStorage.getItem("loginUserId"));
      let flag = true;
      if (userId === dashboardList.createdBy) {
        flag = false;
      } else if (dashboardList.readOnly) {
        flag = false;
      } else if (secureLocalStorage.getItem("loggedClient") === "tenant") {
        flag = false;
      }
      await this.getreportsbylimit(n, dashboardId, widIds, flag);
    } else {
      this.setState({
        ...this.state,
        count: 0,
        progresspercent: 100,
        reportDataList: [],
      });
    }
  };

  getreportsbylimit = (n, dashboardId, widIds, flag) => {
    let skipCnt = 2;
    if (n > 10 && n <= 20) {
      skipCnt = 5;
    } else if (n > 30) {
      skipCnt = 10;
    }
    for (var i = 0; i < n; i += skipCnt) {
      this.asyncReportGeneration(dashboardId, i, skipCnt, n, widIds, flag);
    }
  };
  selectDashboard = async (dashboardId) => {
    const { dashBoardResponseTemp } = this.state;
    let dashboardObj = dashBoardResponseTemp.find(
      (item) => item.dashboardId == dashboardId
    );
    console.log("dashboardObj",dashboardObj);
    if (
      dashboardObj &&
      dashboardObj.widgetCols &&
      dashboardObj.widgetCols.length > 0
    ) {
      let widgetCols=dashboardObj.widgetCols.map(({ chartData, ...rest }) => rest);
      this.setState({
        DbId: dashboardId,
        ActiveViews: 0,
        selectedReports: widgetCols,
        reportDataList: [],
        dashboardName: dashboardObj.name,
        totalReportsCount:dashboardObj.widgetCols.length,
        totalLoadedReportsCount:0,
        dashboardLoaded:false,
        isFreezeDS: false,
      });
    } else {
      this.setState({
        DbId: dashboardId,
        ActiveViews: 0,
        selectedReports: [],
        reportDataList: [],
        totalReportsCount:0,
        totalLoadedReportsCount:0,
        dashboardLoaded:false,
        isFreezeDS: false,
      });
    }
  };
  selectedDB = async (dashboardId) => {
    if (this.disbleAPICall) {
      return;
    }

    this.disbleAPICall = true;
    this.backGroundReportList = [];
    this.isReportLoaded = false;
    this.isSingleReport = false;
    this.isFirstApiCallCompleted = false;
    this.setState({
      reportDataList: [],
      DbId: dashboardId,
      ActiveViews: 0,
      skip: 0,
      take: 4,
    });
    const { dashBoardResponseTemp } = this.state;
    let skip = 0;
    let take = 4;
    let dashboardList = dashBoardResponseTemp.find(
      (item) => item.dashboardId == dashboardId
    );
    let widgetListIds = [];
    if (
      dashboardList &&
      dashboardList.widgetCols &&
      dashboardList.widgetCols.length > 0
    ) {
      this.total = dashboardList.widgetCols.length;
      this.pageSizes = await this.getPagesSize(dashboardList.widgetCols.length);
      widgetListIds = dashboardList.widgetCols.map((e) => {
        return e.widgetId;
      });
      await this.fetchReportsByPagination(
        dashboardId,
        skip,
        take,
        widgetListIds.slice(skip, skip + take)
      );
    } else {
      this.isReportLoaded = true;
      this.isFirstApiCallCompleted = false;
      this.disbleAPICall = false;
      return;
    }

    if (this.total > take) {
      await this.backgroundAPICallForReports(
        dashboardId,
        take,
        this.total,
        widgetListIds.slice(take, this.total)
      );
    } else {
      this.isReportLoaded = true;
      this.isFirstApiCallCompleted = false;
      this.setState({ loader: false });
    }
    this.disbleAPICall = false;
  };

  getPagesSize = (n) => {
    var arr = [4];
    if (n > 5) {
      for (let i = 1; i <= n; i++) {
        if (i % 5 === 0) {
          arr.push(i);
        }
      }
      if (n % 5 != 0) {
        arr.push(n);
      }
    } else {
      arr.push(n);
    }
    return arr;
  };
  // backGroundReportList
  backgroundAPICallForReports = async (
    dashboardId,
    skip,
    take,
    widgetListIds
  ) => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DashBoardId: parseInt(dashboardId),
        skip: skip,
        take: take,
        WidgetListIds: widgetListIds,
      };
      let response = await Api.getReportsByDashboardID(request);
      if (response.status === 200 && response.chartData) {
        let temp = response.chartData.concat(this.state.reportDataList);
        let arr = await this.reportAccessibility(temp, dashboardId);
        this.backGroundReportList = arr;
        this.isFirstApiCallCompleted = false;
        this.setState({
          reportDataList: arr,
          reportDataListFilterData: arr,
        });
      } else {
        this.isFirstApiCallCompleted = false;
        this.setState({
          reportDataListFilterData: [],
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  fetchReportsByPagination = async (dashboardId, skip, take, widgetListIds) => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DashBoardId: parseInt(dashboardId),
        skip: skip,
        take: take,
        WidgetListIds: widgetListIds,
      };
      let response = await Api.getReportsByDashboardID(request);
      if (response.status === 200 && response.chartData) {
        this.isFirstApiCallCompleted = true;
        this.isReportLoaded = true;
        let arr = await this.reportAccessibility(
          response.chartData,
          dashboardId
        );
        //Sorting - persistence
        this.setState({
          reportDataList: arr,
          dashBoardId: dashboardId,
          reportDataListFilterData: arr,
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        loader: false,
      });
    }
  };

  reportAccessibility = async (chartData, dashboardId) => {
    let sortedValue = [];
    try {
      let dashboardList = this.state.dashBoardResponseTemp.find(
        (item) => item.dashboardId == dashboardId
      );
      let widgetListIds = [];
      if (
        dashboardList &&
        dashboardList.widgetCols &&
        dashboardList.widgetCols.length
      ) {
        widgetListIds = dashboardList.widgetCols.map((e) => {
          return e.widgetId;
        });
        const userId = parseInt(secureLocalStorage.getItem("loginUserId"));
        let flag = true;
        if (userId === dashboardList.createdBy) {
          flag = false;
        } else if (dashboardList.readOnly) {
          flag = false;
        } else if (secureLocalStorage.getItem("loggedClient") === "tenant") {
          flag = false;
        }
        let withAccessibility = chartData.map((dataItem) =>
          Object.assign(
            {
              disabled: flag,
              editable: false,
            },
            dataItem
          )
        );
        sortedValue = await this.sortReportsByIds(
          widgetListIds,
          withAccessibility
        );
      }
      return sortedValue;
    } catch (err) {
      console.log(err);
    }
  };

  handlePageChange = (event) => {
    try {
      const { skip, take } = event;

      if (this.total === take) {
        this.showAllReports();
      } else {
        this.setState({
          skip: isNaN(take) ? 0 : skip,
          take: isNaN(take) ? this.total : take,
        });
        console.log(`Page Change: skip ${skip}, take ${take}`);

        let dashboardList = this.state.dashBoardResponseTemp.find(
          (item) => item.dashboardId == this.state.dashboardId
        );
        let widgetListIds = [];
        if (
          dashboardList &&
          dashboardList.widgetCols &&
          dashboardList.widgetCols.length
        ) {
          widgetListIds = dashboardList.widgetCols.map((e) => {
            return e.widgetId;
          });
          widgetListIds = widgetListIds.slice(skip, skip + take);
        }
        if (!this.isReportLoaded) {
          this.fetchReportsByPagination(
            this.state.dashboardId,
            skip,
            take,
            widgetListIds
          );
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  setChartDataToState = () => {
    const { reportDataList } = this.state;
    let pp = reportDataList.filter(
      (ele, ind) =>
        ind ===
        reportDataList.findIndex((elem) => elem.widgetId === ele.widgetId)
    );
    return pp;
  };

  showAllReports = () => {
    let arr = this.backGroundReportList.concat(this.state.reportDataList);
    let dashboardList = this.state.dashBoardResponseTemp.find(
      (item) => item.dashboardId == this.state.DbId
    );
    let widgetListIds = [];
    if (
      dashboardList &&
      dashboardList.widgetCols &&
      dashboardList.widgetCols.length
    ) {
      widgetListIds = dashboardList.widgetCols.map((e) => {
        return e.widgetId;
      });
      const userId = parseInt(secureLocalStorage.getItem("loginUserId"));
      let flag = true;
      if (userId === dashboardList.createdBy) {
        flag = false;
      } else if (dashboardList.readOnly) {
        flag = false;
      } else if (secureLocalStorage.getItem("loggedClient") === "tenant") {
        flag = false;
      }
      let withAccessibility = arr.map((dataItem) => {
        dataItem["disabled"] = flag;
        dataItem["editable"] = false;
        return dataItem;
      });
      let sortedValue = this.sortReportsByIds(widgetListIds, withAccessibility);
      this.backGroundReportList = [];
      this.setState({
        skip: 0,
        take: this.total,
        reportDataList: sortedValue,
      });
    }
  };
  getWidgets = async () => {
    try {
      let response = await Api.getWidgetType();

      if (response.status === 200) {
        this.setState({ ...this.state, widgetTypeList: response.widgetTypes });
      } else {
        this.setState({ ...this.state, widgetTypeList: [] });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, widgetTypeList: [] });
    }
  };

  getDataSource = async () => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        Type: "Risk",
      };
      let response = await Api.getView(request);
      if (response.status === 200) {
        const heatmapCols = response.yAxisColumns.filter(
          (task) =>
            task.colsName != "Frequency" && task.colsName != "MitigationCount"
        );

        var datasource = response.datasource;
        this.setState({
          ...this.state,
          datasourceList: datasource,
          datasourceListTemp: datasource,
          xAxisColumnsList: response.xAxisColumns,
          yAxisColumnsList: response.yAxisColumns,
          heatmapCols: heatmapCols,
        });
      } else {
        this.setState({ ...this.state, data: [] });
      }
      // //console.clear();
    } catch (error) {
      console.error(error);
    }
  };

  getMitigationViewAxis = async () => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };

      let response = await Api.getMitigationViewAxis(request);
      if (response.status === 200) {
        var datasource = response.datasource;
        this.setState({
          ...this.state,
          MitigationDatasourceList: datasource,
          MitigationDatasourceListTemp: datasource,
        });
      } else {
        this.setState({
          ...this.state,
          MitigationDatasourceList: [],
        });
      }
      //console.clear();
    } catch (error) {
      this.setState({
        ...this.state,
        MitigationDatasourceList: [],
      });
      console.error(error);
    }
  };
  handleDataSource = (event) => {
    this.setState({
      ...this.state,
      datasource: event.target.value,
    });
    const project = event.target.value.some(
      (element) => element.id === "project"
    );
    const organizationsUnit = event.target.value.some(
      (element) => element.id === "organizationsUnit"
    );
    const risk = event.target.value.some((element) => element.id === "risk");
    var colsData = [];

    if (project) {
      colsData = [...colsData, ...widgetData.project];
    }
    if (organizationsUnit) {
      colsData = [...colsData, ...widgetData.orgUnitCols];
    }
    if (risk) {
      colsData = [...colsData, ...widgetData.risk];
    }
    this.setState({
      colsData: colsData,
    });
  };

  getChatImage = (img) => {
    var chartImg = "";
    if (img === "BARCHART") {
      chartImg = Images.BARCHART;
    } else if (img === "TEXTWIDGET") {
      chartImg = Images.TEXT;
    } else if (img === "KPI") {
      chartImg = Images.VIEWLIST;
    } else if (img === "DOUGHNUTCHART") {
      chartImg = Images.DASHBOARDICON;
    } else if (img === "BUBBLECHART") {
      chartImg = Images.BUBBLECHART;
    } else if (img === "GAUGECHART") {
      chartImg = Images.GAUGECHART;
    } else if (img === "PIECHART") {
      chartImg = Images.PIECHART;
    } else if (img === "GRIDCHART") {
      chartImg = Images.GRIDCHART;
    } else if (img === "LINECHART") {
      chartImg = Images.LINECHART;
    } else if (img === "AREACHART") {
      chartImg = Images.AREACHART;
    } else if (img === "HEATMAP") {
      chartImg = Images.HEATMAP;
    } else if (img === "BURNDOWNCHART") {
      chartImg = Images.AREACHART;
    } else if (img === "DATA") {
      chartImg = Images.VIEWDATA;
    } else if (img === "TRENDINGCHART") {
      chartImg = Images.GAUGECHART;
    }
    return chartImg;
  };

  CreateDashboardClose = () => {
    this.setState({
      ...this.state,
      openCreateDashboard: false,
      editFlag: false,
      name: "",
      scope: "0",
      value: [],
      editDashBoardData: {},
    });
  };

  CreateDashboardOpen = (flag, item) => {
    if (flag === "Edit") {
      this.setState({
        ...this.state,
        editFlag: true,
        editDashBoardData: item,
        openCreateDashboard: true,
      });
      this.refs.dashboardChild.papulateDashboardValues(item);
    } else {
      this.setState({
        openCreateDashboard: true,
        editFlag: false,
        editDashBoardData: {},
      });
    }
  };

  saveDashboard = async (data) => {
    if (!data || !data.name) {
      return;
    }
    try {
      var request = {
        Name: data.name,
        Scope: parseInt(data.scope),
        ColorCode: "",
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        accessibility: data.scope == "0" ? [] : data.accessibility,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.saveDashboard(request);
      if (response.status === 200) {
        this.setState({
          ...this.state,
          loader: false,
          name: "",
          editFlag: false,
        });
        toastr.success(response.message);
        this.CreateDashboardClose();
        this.getuserAddedByTenant();
        this.getDashboard(false);
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
      //console.clear();
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  getDashboard = async (isReportRefresh) => {
    try {
      if (isReportRefresh) {
        this.setState({ ...this.state, loader: true });
      }
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getDashboard(request);
      if (response.status === 200 && response.dashboards) {
        let filtered = [];

        if (
          this.state.dashboardScopePriate === true &&
          this.state.dashboardScopePublic === false
        ) {
          filtered = response.dashboards.filter((item) => item.scope === 0);
          this.setState({
            ...this.state,
            dashBoardResponse: filtered,
            dashBoardResponseTemp: response.dashboards,
            selectedReports: [],
            DbId: 0,
          });
        } else if (
          this.state.dashboardScopePriate === false &&
          this.state.dashboardScopePublic === true
        ) {
          filtered = response.dashboards.filter((item) => item.scope === 1);
          this.setState({
            ...this.state,
            dashBoardResponse: filtered,
            dashBoardResponseTemp: response.dashboards,
            selectedReports: [],
            DbId: 0,
          });
        } else {
          filtered = response.dashboards;
          this.setState({
            ...this.state,
            dashBoardResponse: filtered,
            dashBoardResponseTemp: response.dashboards,
          });
        }

        if (isReportRefresh) {
          this.setState({
            ...this.state,
            loader: false,
          });
          if (this.props.location.dashboardId) {
            await this.selectDashboard(this.props.location.dashboardId);
            this.setState({
              ...this.state,
              DbId: this.props.location.dashboardId,
            });
          } else if (this.state.DbId) {
            await this.selectDashboard(this.state.DbId);
            this.setState({
              ...this.state,
              DbId: this.state.DbId,
            });
          } else {
            if (response.dashboards && response.dashboards.length > 0) {
              var data = response.dashboards[0];
              this.selectDashboard(data.dashboardId);
            }
          }
        }
      } else {
        this.isReportLoaded = true;
        this.isFirstApiCallCompleted = false;
        this.setState({
          ...this.state,
          loader: false,
          dashBoardResponse: [],
        });
      }
      // console.clear();
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  refreshDashboard = async (dashBoardId) => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getDashboard(request);
      if (response.status === 200 && response.dashboards) {
        this.setState({
          ...this.state,
          loader: false,
          dashBoardResponse: response.dashboards,
          dashBoardResponseTemp: response.dashboards,
        });

        await this.selectDashboard(dashBoardId);
      } else {
        this.setState({
          ...this.state,
          loader: false,
          dashBoardResponse: [],
        });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  // dashboard functions
  deleteDashBoard = (item) => {
    this.setState({
      ...this.state,
      openDeleteModelFlag: true,
      dashBoardId: item.dashboardId,
    });
  };

  deleteDashboardPopupClose = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlag: false,
      dashBoardId: null,
    });
  };

  removeDashboard = async () => {
    try {
      const requestParams = {
        DeletedBy: this.state.dashBoardId,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteDashboard(requestParams);
      if (response.status === 200) {
        this.setState({
          ...this.state,
          loader: false,
          reportDataList: [],
          reportDataListFilterData: [],
        });
        toastr.success(response.message);
        this.deleteDashboardPopupClose();
        this.getDashboard(false);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
      //console.clear();
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  editDashBoard = (item) => {
    this.CreateDashboardOpen("Edit", item);
  };

  openWidget = async (flag) => {
    this.refs.childWidget.createWidgetdOpen(flag);
  };

  updateDashboard = async (data) => {
    if (!data.name) {
      return;
    }
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient === "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        Name: data.name,
        Scope: parseInt(data.scope),
        UpdatedBy: parseInt(createdby),
        DashBoardId: data.dashBoardId,
        accessibility: data.scope == "0" ? [] : data.accessibility,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.updateDashboard(request);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.CreateDashboardClose();
        this.getuserAddedByTenant();
        this.getDashboard(false);
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
      //console.clear();
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  openDeletePopup = (data, type) => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: true,
      viewData: data,
    });
  };

  closeDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: false,
    });
  };

  openFreezePopup = (data) => {
    this.setState({
      ...this.state,
      openFreezeModelFlagView: true,
      freezeDashBoardId: data.dashboardId,
      freezeEditMode: false,
      freezeDashboardDetails: data,
      enablefreezedashborad: false,
    });
  };
  closeFreezePopup = () => {
    this.setState({
      ...this.state,
      openFreezeModelFlagView: false,
      freezeDashBoardId: 0,
      freezeName: "",
      value: [],
      scope: "0",
      freezeEditMode: false,
      freezeDashboardDetails: null,
    });
  };

  openEditFreezeDashboardPopup = (data) => {
    this.setState({
      ...this.state,
      openFreezeModelFlagView: true,
      freezeEditMode: true,
      freezeDashBoardDetails: data,
      scope: data.scope ? "1" : "0",
      freezeName: data.name,
      value: data.accessibility,
      freezeDashBoardId: data.dashboardId,
      enablefreezedashborad: !this.state.enablefreezedashborad,
    });
  };

  openDeleteFreezeDashBoard = (data) => {
    this.setState({
      ...this.state,
      openDeleteFreezeModelFlag: true,
      freezeDashBoardId: data.dashboardId,
    });
  };
  closeDeleteFreezeDashBoard = () => {
    this.setState({
      ...this.state,
      openDeleteFreezeModelFlag: false,
      freezeDashBoardId: 0,
    });
  };

  removeFreezeDashBoard = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      let request = {
        DashBoardId: this.state.freezeDashBoardId,
        DeletedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DeletedDate: new Date(),
      };
      let response = await Api.deleteFrozenDashboard(request);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false, reportDataList: [] });
        toastr.success(response.message);
        this.closeDeleteFreezeDashBoard();
        this.getFrozenDashboard();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (err) {
      this.setState({ ...this.state, loader: false });
      console.log(err);
    }
  };

  freezeDashboard = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      let request = {
        name: this.state.freezeName
          ? this.state.freezeName
          : "FreezeDashboard" + new Date(),
        DashBoardId: this.state.freezeDashBoardId,
        createdBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        createdDate: new Date(),
        accessibility: this.state.value,
        scope: parseInt(this.state.scope),
      };
      let response = await Api.freezeDashboard(request);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.closeFreezePopup();
        this.getFrozenDashboard();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (err) {
      console.log(err);
      this.setState({ ...this.state, loader: false });
    }
  };

  updateFrozenDashboard = async () => {
    try {
      if (
        this.state.freezeName.length === 0 ||
        this.state.freezeName.trim() === ""
      ) {
        toastr.error("Name Field is required");
      } else {
        this.setState({ ...this.state, loader: true });
        let request = {
          name: this.state.freezeName,
          DashBoardId: this.state.freezeDashBoardId,
          createdBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          createdDate: new Date(),
          accessibility: this.state.value,
          scope: parseInt(this.state.scope),
        };
        let response = await Api.updateFrozenDashboard(request);
        if (response.status === 200) {
          this.setState({ ...this.state, loader: false });
          toastr.success(response.message);
          this.closeFreezePopup();
          this.getFrozenDashboard();
        } else {
          this.setState({ ...this.state, loader: false });
          toastr.error(response.message);
        }
      }
    } catch (err) {
      this.setState({ ...this.state, loader: false });
      console.log(err);
    }
  };
  openFreezeReport = async (data) => {
    this.isReportLoaded = false;
    this.setState({
      ...this.state,
      loader: false,
      reportDataList: [],
      progresspercent: 0,
    });
    await this.getFrozenWidgets(data);
  };

  getFrozenWidgets = async (data) => {
    try {
      this.setState({
        ...this.state,
        selectedReports: [],
        reportDataList: [],
        ActiveViews: data.dashboardId,
        isFreezeDS: true,
        DbId: 0,
      });
      let request = {
        id: data.dashboardId,
      };
      let response = await Api.getFrozenWidgets(request);
      if (response.status === 200) {
        let chartData = await this.toCamel(response.widgetResponse);
        let disbaledData =
          chartData &&
          chartData.map((item) => {
            item["disabled"] = true;
            return item;
          });
        this.setState({
          ...this.state,
          reportDataList: disbaledData,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
          reportDataList: [],
        });
      }
    } catch (err) {
      this.setState({ ...this.state, loader: false });
      console.log(err);
    }
  };
  toCamel = (o) => {
    var newO, origKey, newKey, value;
    if (o instanceof Array) {
      return o.map((value) => {
        if (typeof value === "object") {
          value = this.toCamel(value);
        }
        return value;
      });
    } else {
      newO = {};
      for (origKey in o) {
        if (o.hasOwnProperty(origKey)) {
          newKey = (
            origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey
          ).toString();
          value = o[origKey];
          if (
            value instanceof Array ||
            (value !== null && value.constructor === Object)
          ) {
            value = this.toCamel(value);
          }
          newO[newKey] = value;
        }
      }
    }
    return newO;
  };
  getFrozenDashboard = async () => {
    try {
      let request = {
        createdBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getFrozenDashboard(request);
      if (response.status === 200) {
        this.setState({
          ...this.state,
          freezeDashboardList: response.shareDasboards,
        });
      } else {
        this.setState({ ...this.state, freezeDashboardList: [] });
      }
    } catch (err) {
      console.log(err);
    }
  };

  removeView = async () => {
    try {
      const requestParams = {
        DeletedBy: this.state.viewData.id,
      };

      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteView(requestParams);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.closeDeletePopup();
        this.getDataSource();
        this.getMitigationViewAxis();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
      //console.clear();
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  ToggleRiskDataset = () => {
    this.setState({ showRiskDataSet: !this.state.showRiskDataSet });
  };
  ToggleActionDataset = () => {
    this.setState({ showActionDataSet: !this.state.showActionDataSet });
  };

  ToggleFreezeDashboardReport = () => {
    this.setState({
      showFreezeReportList: !this.state.showFreezeReportList,
    });
    console.log(this.state.showFreezeReportList);
  };

  ToggleDashboardReport = () => {
    this.setState({
      showDashboardList: !this.state.showDashboardList,
    });
  };

  selectedViews = (item) => {
    secureLocalStorage.setItem("ActivePage", "Mitigations");

    const token =
      secureLocalStorage.getItem("loggedClient") === "user"
        ? secureLocalStorage.getItem("userKey")
        : secureLocalStorage.getItem("tenantKey");
    const loggedClient = secureLocalStorage.getItem("loggedClient");
    this.setState({ ...this.state, ActiveViews: item.id });
    this.props.history.push({
      pathname: `/${loggedClient}/${token}/home/datasets`,
    });
  };
  editView = (data) => {
    secureLocalStorage.setItem("ActivePage", "Mitigations");

    const token =
      secureLocalStorage.getItem("loggedClient") === "user"
        ? secureLocalStorage.getItem("userKey")
        : secureLocalStorage.getItem("tenantKey");
    const loggedClient = secureLocalStorage.getItem("loggedClient");
    this.props.history.push({
      pathname: `/${loggedClient}/${token}/home/datasets`,
      viewData: data,
      type: "RISK",
    });
  };
  editActionView = (data) => {
    secureLocalStorage.setItem("ActivePage", "Mitigations");

    const token =
      secureLocalStorage.getItem("loggedClient") === "user"
        ? secureLocalStorage.getItem("userKey")
        : secureLocalStorage.getItem("tenantKey");
    const loggedClient = secureLocalStorage.getItem("loggedClient");
    this.props.history.push({
      pathname: `/${loggedClient}/${token}/home/datasets`,
      viewData: data,
      type: "ACTION",
    });
  };
  handleSetWidgetId = (widgetId) => {
    let widgetValue = this.state.expandWidgetId.indexOf(widgetId);
    if (widgetValue !== -1) {
      this.state.expandWidgetId.splice(widgetValue, 1);
      this.setState({ expandWidgetId: this.state.expandWidgetId });
    } else {
      let value = this.state.expandWidgetId;
      value.push(widgetId);
      this.setState({ expandWidgetId: value });
    }
  };

  refreshTextWidget = (htmlData, widgetId, editable) => {
    let data =
      this.state.reportDataList &&
      this.state.reportDataList.map((item) => {
        if (item.widgetId == widgetId) {
          item["textWidgetData"] = htmlData;
          item["editable"] = editable;
        }
        return item;
      });
    this.setState({ reportDataList: data });
  };

  refreshTextNarative = (text, widgetId) => {
    let data =
      this.state.reportDataList &&
      this.state.reportDataList.map((item) => {
        if (item.widgetId == widgetId) {
          item["textNarrative"] = text;
        }
        return item;
      });

    this.setState({ reportDataList: data });
  };

  getRiskDataByViewId = async (viewData, type) => {
    try {
      const requestParams = {
        ViewId: viewData.id,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getByViewId(requestParams);

      if (response.status === 200) {
        response.riskRegister.map((riskReg) => {
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
        });
        this.setState({
          ...this.state,
          riskList: response.riskRegister,
          loader: false,
        });
      } else {
        this.setState({ ...this.state, riskList: [], loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  searchDashboard = (keyword) => {
    var filtered = [];
    if (this.state.dashboardScope) {
      var filteredArray = this.state.dashBoardResponseTemp.filter(
        (item) => item.scope !== parseInt(this.state.dashboardScope)
      );
      filtered = filteredArray.filter((entry) =>
        Object.values(entry).some(
          (val) =>
            typeof val === "string" &&
            val.toLocaleLowerCase().includes(keyword.toLocaleLowerCase())
        )
      );
    } else {
      filtered = this.state.dashBoardResponseTemp.filter((entry) =>
        Object.values(entry).some(
          (val) =>
            typeof val === "string" &&
            val.toLocaleLowerCase().includes(keyword.toLocaleLowerCase())
        )
      );
    }
    this.setState({
      ...this.state,
      dashBoardResponse: filtered,
      dashboardScopeSearch: keyword,
    });
  };

  filterDashboardPublic = (e) => {
    let filtered = [];
    if (e.target.checked === true && this.state.dashboardScopePriate === true) {
      filtered = this.state.dashBoardResponseTemp;
    } else if (e.target.checked === true) {
      filtered = this.state.dashBoardResponseTemp.filter(
        (item) => item.scope === parseInt(e.target.value)
      );
    } else if (
      e.target.checked === false &&
      this.state.dashboardScopePriate === false
    ) {
      filtered = [];
    } else {
      filtered = this.state.dashBoardResponseTemp.filter(
        (item) => item.scope !== parseInt(e.target.value)
      );
    }
    let flag = filtered.find((item) => item.dashboardId === this.state.DbId);
    if (flag) {
      this.setState({
        ...this.state,
        dashBoardResponse: filtered,
        dashboardScope: e.target.value,
        dashboardScopeSearch: "",
        dashboardScopePublic: e.target.checked,
      });
    } else {
      this.setState({
        ...this.state,
        dashBoardResponse: filtered,
        dashboardScope: e.target.value,
        dashboardScopeSearch: "",
        dashboardScopePublic: e.target.checked,
        selectedReports: [],
        DbId: 0,
      });
    }
  };
  filterDashboardPrivate = (e) => {
    let filtered = [];
    if (e.target.checked === true && this.state.dashboardScopePublic === true) {
      filtered = this.state.dashBoardResponseTemp;
    } else if (e.target.checked === true) {
      filtered = this.state.dashBoardResponseTemp.filter(
        (item) => item.scope === parseInt(e.target.value)
      );
    } else if (
      e.target.checked === false &&
      this.state.dashboardScopePublic === false
    ) {
      filtered = [];
    } else {
      filtered = this.state.dashBoardResponseTemp.filter(
        (item) => item.scope !== parseInt(e.target.value)
      );
    }
    let flag = filtered.find((item) => item.dashboardId === this.state.DbId);

    if (flag) {
      this.setState({
        ...this.state,
        dashBoardResponse: filtered,
        dashboardScope: e.target.value,
        dashboardScopeSearch: "",
        dashboardScopePriate: e.target.checked,
      });
    } else {
      this.setState({
        ...this.state,
        dashBoardResponse: filtered,
        dashboardScope: e.target.value,
        dashboardScopeSearch: "",
        dashboardScopePriate: e.target.checked,
        selectedReports: [],
        DbId: 0,
      });
    }
  };

  handleChange = (event) => {
    this.setState({
      value: event.target.value,
    });
    console.log(event.target.value);
  };

  itemRender = (li, itemProps) => {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          checked={itemProps.selected}
          onChange={() => {}}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };

  generateMultipleBase = async () => {
    let tempData = [];
    const { selectedReports, reportDataList } = this.state;
    let arr = this.state.isFreezeDS ? reportDataList : selectedReports;
    console.log("arr", arr);
    for (let index = 0; index < arr.length; index++) {
      try {

        if (
          arr[index].widgetTypeName !== "TEXTWIDGET" &&
          arr[index].widgetTypeName !== "DOUGHNUTCHART" &&
          arr[index].widgetTypeName !== "DATA" &&
          arr[index].widgetTypeName !== "HEATMAP"
        ) {
          let htmlId = "#c" + arr[index].widgetId;
          let gridElement = document.querySelector(htmlId);

          // 1. Find the .textnarrativeexport inside this chart
          let narrativeElement = gridElement?.querySelector(
            ".textnarrativeexport"
          );

          if (narrativeElement) {
            // 2. Temporarily make it visible
            narrativeElement.style.display = "block";

            // 3. Assign new text value inside the <p> tag
            let pTag = narrativeElement.querySelector("p");
            if (pTag) {
              const narrativeText = arr[index]?.chartData?.textNarrative || "";
              pTag.textContent = narrativeText;
            }
          }
          //================ transparency Start ===========================

          // Function to recursively set background to transparent for all elements
          const makeTransparent = (element, originalStyles, prefix) => {
            // Store original background
            originalStyles[`${prefix}_bg`] = element.style.backgroundColor;
            originalStyles[`${prefix}_bgImg`] = element.style.backgroundImage;

            // Set background to transparent
            element.style.backgroundColor = "transparent";
            element.style.backgroundImage = "none";

            // Process all child elements
            Array.from(element.children).forEach((child, index) => {
              makeTransparent(child, originalStyles, `${prefix}_${index}`);
            });

            return originalStyles;
          };

          // Function to restore original backgrounds
          const restoreBackgrounds = (element, originalStyles, prefix) => {
            // Restore background
            element.style.backgroundColor =
              originalStyles[`${prefix}_bg`] || "";
            element.style.backgroundImage =
              originalStyles[`${prefix}_bgImg`] || "";

            // Process all child elements
            Array.from(element.children).forEach((child, index) => {
              restoreBackgrounds(child, originalStyles, `${prefix}_${index}`);
            });
          };

          // Store original styles and make all elements transparent
          const originalStyles = {};
          makeTransparent(gridElement, originalStyles, "root");

          // Add a temporary style tag with aggressive selectors
          const styleTag = document.createElement("style");
          styleTag.innerHTML = `
      #${gridElement.id},
      #${gridElement.id} *,
      #${gridElement.id} *::before,
      #${gridElement.id} *::after {
        background-color: transparent !important;
        background-image: none !important;
        background: transparent !important;
        fill: transparent !important;
        color: black !important;
        padding-left: 8px;
      }
        .flexLabel{
        padding-left: 17px !important;
      }
          .wgHeader{
        padding-left: 10px !important;
        }
        /* Put these AFTER the global transparency override */
        #${gridElement.id} .originalCompletionDate {
          background-color: rgb(206, 237, 248) !important;
        }

        #${gridElement.id} .projectedCompletionDate {
          background-color: rgb(227, 241, 22) !important;
        }

        #${gridElement.id} .actualCompletionDate {
          background-color: rgb(34, 159, 204) !important;
        }
   #${gridElement.id} .mitigated{background-color: rgb(248, 220, 135) !important;}
  #${gridElement.id} .unmitigated{background-color:rgb(255, 138, 130) !important;}
  #${gridElement.id} .mitigatedend{background-color:rgb(255, 210, 70) !important;}
  #${gridElement.id} .umitigatedend{background-color: rgb(255, 99, 88) !important;}
  #${gridElement.id} .originalCompletionDate{background-color: rgb(206,237,248) !important;}
  #${gridElement.id} .projectedCompletionDate{background-color: rgb(227, 241, 22) !important;}
  #${gridElement.id} .actualCompletionDate{background-color:rgb(34,159,204) !important;}  
  #${gridElement.id} .currentValue{background-color:rgb(8, 77, 167) !important;}
   #${gridElement.id} .currentValueEnd{background-color:rgba(45, 125, 230, 1);}
    #${gridElement.id} .pieContainer {
          position: relative;
          padding-left: 50px;
          padding-bottom: 40px;
      }
      .pieContainer .pieY {
        padding-left: 40px !important;
      }
      .textnarrativeexport {
        color: black !important;
        font-size: 12px;
        font-family: "Barlow";
        src: url("./riskwell/Assets/Fonts/Barlow-Medium.ttf");
        font-style: normal;
      }
      /* Target specific Kendo chart elements */
      .k-chart-surface,
      .k-chart-area,
      .k-chart svg,
      .k-chart svg rect,
      .k-chart-plot-area,
      .k-chart-pane {
        background-color: transparent !important;
        background: transparent !important;
        fill: transparent !important;
        color: black !important;
      }
    `;
          document.head.appendChild(styleTag);

          // If this is a Kendo chart, try to update its options directly
          if (this._chart && typeof this._chart.setOptions === "function") {
            try {
              const currentOptions = this._chart.options || {};
              this._chart.setOptions({
                ...currentOptions,
                chartArea: {
                  ...currentOptions.chartArea,
                  background: "transparent",
                },
                plotArea: {
                  ...currentOptions.plotArea,
                  background: "transparent",
                },
              });
            } catch (e) {
              console.error("Error updating chart options:", e);
            }
          }

          // Force a repaint
          gridElement.style.display = "none";
          void gridElement.offsetHeight;
          gridElement.style.display = "";
          //================ transparency End ===========================

          drawDOM(gridElement)
            .then((group) => {
              // Try to modify the group to ensure transparency
              try {
                if (group && group.children) {
                  group.children.forEach((child) => {
                    if (child.options) {
                      child.options.background = "transparent";
                    }
                  });
                }
              } catch (e) {
                console.error("Error modifying group:", e);
              }
              return exportPDF(group, {
                background: "transparent",
                margin: { left: 10, top: 10, right: 10, bottom: 50 }, // Add bottom margin for footer space
              });
            })
            .then((dataURI) => {
              tempData.push(dataURI.split(";base64,")[1]);
            })
            .catch((error) => {
              console.error("PDF export error:", error);
            })
            .finally(() => {
              // Clean up - remove the style tag
              document.head.removeChild(styleTag);

              // Restore original backgrounds
              restoreBackgrounds(gridElement, originalStyles, "root");

              // If we modified the chart options, try to restore them
              if (this._chart && typeof this._chart.setOptions === "function") {
                try {
                  this._chart.refresh();
                } catch (e) {
                  console.error("Error refreshing chart:", e);
                }
              }

              if (narrativeElement) {
                // 5. After export, remove the temporary text or hide the element
                narrativeElement.style.display = "none";
                let pTag = narrativeElement.querySelector("p");
                if (pTag) {
                  pTag.textContent = ""; // clear the text if needed
                }
              }
            });
        } else if (arr[index].widgetTypeName === "HEATMAP") {
          const chartId = arr[index].widgetId;

          let htmlId = "#c" + arr[index].widgetId;
          const originalElement = document.querySelector(htmlId);

          // Clone the element to avoid mutations
          const gridElement = originalElement.cloneNode(true);
          gridElement.id = "export_" + chartId; // New unique ID for the cloned export
          // ✅ Hide it off-screen instead of showing at bottom
          gridElement.style.position = "absolute";
          gridElement.style.top = "-9999px";
          gridElement.style.left = "-9999px";
          // gridElement.style.visibility = "hidden";

          document.body.appendChild(gridElement);

          // ========= Narrative Setup =========
          const narrativeElement = gridElement.querySelector(
            ".textnarrativeexport"
          );
          if (narrativeElement) {
            narrativeElement.style.display = "block";
            // Add bottom padding to prevent overlap with footer
            narrativeElement.style.paddingBottom = "60px";
            narrativeElement.style.marginBottom = "60px";

            const pTag = narrativeElement.querySelector("p");
            if (pTag) {
              const narrativeText = arr[index]?.chartData?.textNarrative || "";
              pTag.textContent = narrativeText;
            }
          }

          // ========= Temporary Styling =========
          const styleTag = document.createElement("style");
          styleTag.setAttribute("data-export-style", chartId);
          styleTag.innerHTML = `
    #export_${chartId} {
      background: white !important;
      font-family: "Barlow", sans-serif !important;
    }

    #export_${chartId} * {
      color: black !important;
      font-size: 12px !important;
      font-family: "Barlow", sans-serif !important;
    }
 /* Specific targeting for the dataset header which appears to have a black background */
      #export_${chartId} .wgHeader {
        background-color: white !important;
        color: black !important;
        border: none !important;
        margin: 0 !important;
        padding: 10px !important;
      }
      
      #export_${chartId} .wgHeader h4 {
        background-color: white !important;
        color: black !important;
        margin: 0 !important;
      }
    #export_${chartId} .textnarrativeexport {
  display: block !important;
  color: black !important;
  width: 100% !important;
  max-width: 1000px !important; /* Constrain width */
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  padding: 10px !important;
  padding-bottom: 60px !important; /* Add extra padding at bottom for footer */
  margin-bottom: 60px !important; /* Add extra margin at bottom for footer */
  box-sizing: border-box !important;
}

#export_${chartId} .textnarrativeexport p {
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  font-size: 12px !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1.4;
  width: 100% !important;
  max-width: 100% !important;
}
   #export_${chartId} .heatmap_timestamp{
font-size: 16px !important;
      font-weight: normal !important;
      color: black !important;
    }
    #export_${chartId} .wgHeader h4 {
      font-size: 12px !important;
      font-weight: normal !important;
      color: black !important;
    }

    #export_${chartId} .heatmapHeader {
      background-color: white !important;
    }
  `;
          document.head.appendChild(styleTag);

          // Force layout refresh
          gridElement.style.display = "none";
          void gridElement.offsetHeight;
          gridElement.style.display = "";

          // ========= Export to PDF =========
          try {
            const group = await drawDOM(gridElement, {
              paperSize: "auto",
              margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "2cm" }, // Increased bottom margin
              scale: 1,
              forcePageBreak: ".pdf-page-break",
              background: "#ffffff",
            });

            const dataURI = await exportPDF(group, {
              background: "#ffffff",
              margin: { left: 10, top: 10, right: 10, bottom: 70 }, // Increased bottom margin for footer
            });
            tempData.push(dataURI.split(";base64,")[1]);
            //  saveAs(dataURI, `${widgetName}.pdf`);
          } catch (error) {
            console.error("PDF export error:", error);
          } finally {
            // Clean up
            const oldStyle = document.querySelector(
              `style[data-export-style="${chartId}"]`
            );
            if (oldStyle) document.head.removeChild(oldStyle);
            document.body.removeChild(gridElement);

            if (narrativeElement) {
              narrativeElement.style.display = "none";
              const pTag = narrativeElement.querySelector("p");
              if (pTag) pTag.textContent = "";
            }
          }
        } 
      } catch (err) {
        console.error(err);
      }
    }
    return tempData;
  };

  pdfDocCreation = async () => {
    try {

      const base64Array = await this.generateMultipleBase();

      setTimeout(async () => {
        const pdfDoc1 =
          base64Array.length > 0 ? await PDFDocument.load(base64Array[0]) : "";
        
        // Set font for page numbers
        const helveticaFont = await pdfDoc1.embedFont('Helvetica');
        
        // Add first page with proper spacing
        if (base64Array.length > 0) {
          const pages = pdfDoc1.getPages();
          const firstPage = pages[0];
          
          // Add page number to first page
          const { width, height } = firstPage.getSize();
          firstPage.drawText(`1 / ${base64Array.length}`, {
            x: width / 2,
            y: 30, // Bottom margin for page number
            size: 10,
            font: helveticaFont,
            // color: { r: 0, g: 0, b: 0 },
          });
        }
        
        // Add remaining pages with page numbers
        for (let index = 1; index < base64Array.length; index++) {
          const temp = await PDFDocument.load(base64Array[index]);
          const [existingPage] = await pdfDoc1.copyPages(temp, [0]);
          
          // Add the page to the document
          pdfDoc1.addPage(existingPage);
          
          // Get the newly added page and add page number
          const pages = pdfDoc1.getPages();
          const currentPage = pages[pages.length - 1];
          const { width, height } = currentPage.getSize();
          
          // Add page number at the bottom center
          currentPage.drawText(`${index + 1} / ${base64Array.length}`, {
            x: width / 2,
            y: 30, // Bottom margin for page number
            size: 10,
            font: helveticaFont,
            // color: { r: 0, g: 0, b: 0 },
          });
        }
        
        const dataURI = await pdfDoc1?.save();
        var blob = new Blob([dataURI], { type: "application/pdf" });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = this.state.dashboardName + ".pdf";
        link.click();

        this.setState({
          ...this.state,
          showTableFromDashboard: false,
          emailloader: false,
        });
      }, 2000);
    } catch (err) {
      console.error(err);
      toastr.error("Failed");
      this.setState({
        ...this.state,
        showTableFromDashboard: false,
        emailloader: false,
      });
    }
  };

  generatePdf = async () => {
    this.setState({
      ...this.state,
      showTableFromDashboard: true,
      emailloader: true,
    });
    setTimeout(async () => {
      await this.pdfDocCreation();
    }, 10000);
  };
  handleWidgetFullView = (expandWidgetId, widget) => {
    let widgetView = expandWidgetId.filter((item) => item === widget);
    if (widgetView.length > 0) {
      return true;
    } else {
      return false;
    }
  };
  getReportComponenets = (item) => {
    let componant = <div></div>;
    if (item.widgetTypeName === "LINECHART") {
      componant = (
        <LineChartContainer
          isTenentAdmin={this.isTenentAdmin}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          isFreezeDS={this.state.isFreezeDS}
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
        />
      );
    } else if (item.widgetTypeName === "TRENDINGCHART") {
      componant = (
        <TrendingLineChart
          isTenentAdmin={this.isTenentAdmin}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          isFreezeDS={this.state.isFreezeDS}
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
        />
      );
    } else if (item.widgetTypeName === "BURNDOWNCHART") {
      componant = (
        <BurnDownChartContainer
          isTenentAdmin={this.isTenentAdmin}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          isFreezeDS={this.state.isFreezeDS}
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
        />
      );
    } else if (item.widgetTypeName === "BARCHART") {
      componant = (
        <BarChartContainer
          isTenentAdmin={this.isTenentAdmin}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          isFreezeDS={this.state.isFreezeDS}
          dragFlag={this.state.dragFlag}
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
        />
      );
    } else if (item.widgetTypeName === "TEXTWIDGET") {
      componant = (
        <RichTextChart
          isTenentAdmin={this.isTenentAdmin}
          refreshTextWidget={this.refreshTextWidget}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          isFreezeDS={this.state.isFreezeDS}
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
        />
      );
    } else if (
      item.widgetTypeName === "DATA" &&
      (item.reportType === "Action" || item.reportType === "Mitigation")
    ) {
      componant = (
        <DataReportForAction
          isTenentAdmin={this.isTenentAdmin}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          isFreezeDS={this.state.isFreezeDS}
          customFieldsmaster={this.state.customFieldsmaster}
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
        />
      );
    } else if (item.widgetTypeName === "DATA" && item.reportType === "Risk") {
      componant = (
        <DataReportForRisk
          isTenentAdmin={this.isTenentAdmin}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          isFreezeDS={this.state.isFreezeDS}
          customFieldsmaster={this.state.customFieldsmaster}
          HeatMapConfigDataOpportunity={this.state.HeatMapConfigDataOpportunity}
          HeatMapConfigDataThreat={this.state.HeatMapConfigDataThreat}
          dynamicHeatmapProbabilityRange={
            this.state.dynamicHeatmapProbabilityRange
          }
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
        />
      );
    } else if (item.widgetTypeName === "DATA" && item.reportType === "Task") {
      componant = (
        <DataReportForTasks
          isTenentAdmin={this.isTenentAdmin}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          isFreezeDS={this.state.isFreezeDS}
          customFieldsmaster={this.state.customFieldsmaster}
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
        />
      );
    } else if (
      item.widgetTypeName === "DATA" &&
      item.reportType === "TaskAction"
    ) {
      componant = (
        <DataReportForActivities
          isTenentAdmin={this.isTenentAdmin}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          isFreezeDS={this.state.isFreezeDS}
          customFieldsmaster={this.state.customFieldsmaster}
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
        />
      );
    } else if (item.widgetTypeName === "KPI" && item.reportType != "Task") {
      componant = (
        <TileChart
          isTenentAdmin={this.isTenentAdmin}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          isFreezeDS={this.state.isFreezeDS}
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
        />
      );
    } else if (item.widgetTypeName === "KPI" && item.reportType === "Task") {
      componant = (
        <TaskKPITileChart
          isTenentAdmin={this.isTenentAdmin}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          isFreezeDS={this.state.isFreezeDS}
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
        />
      );
    } else if (item.widgetTypeName === "DOUGHNUTCHART") {
      componant = (
        <Histogramwidget
          isTenentAdmin={this.isTenentAdmin}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          isFreezeDS={this.state.isFreezeDS}
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
        />
      );
    } else if (item.widgetTypeName === "PIECHART") {
      componant = (
        <PieChartContainer
          isTenentAdmin={this.isTenentAdmin}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          isFreezeDS={this.state.isFreezeDS}
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
          overAllDownlad={this.state.emailloader}

        />
      );
    } else if (item.widgetTypeName === "HEATMAP" && item.timeStamp == false) {
      componant = (
        <HeatMapChartContainer
          isTenentAdmin={this.isTenentAdmin}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          swapAxisValue={this.state.swapAxisValue}
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
        />
      );
    } else if (item.widgetTypeName === "HEATMAP" && item.timeStamp == true) {
      componant = (
        <HeatMapTimeStamp
          isTenentAdmin={this.isTenentAdmin}
          reportId={item.widgetId}
          dashboardId={this.state.DbId}
          flag={true}
          expandIcon={true}
          changeLineChartWidth={this.handleSetWidgetId}
          swapAxisValue={this.state.swapAxisValue}
          updateResponse={this.updateReportCols}
          chartInputs={item.chartData}
          selectedDB={this.getDashboard}
          selectedDashboard={this.state.selectedDashboard}
        />
      );
    }
    return componant;
  };

  updateReportCols = (reportId, chartData) => {
    try {
      let count=0;
      let data = this.state.selectedReports.map((item) => {
        if (reportId === item.widgetId) {
          item["chartData"] = chartData;

          item["widgetName"] = chartData.widgetName;
          item["name"] = chartData.widgetName;
          item["title"] = chartData.title;
          item["description"] = chartData.description;
          count=this.state.totalLoadedReportsCount+1;
        }
        return item;
      });

      this.setState(
        {
          ...this.state,
          selectedReports: data,
          totalLoadedReportsCount:count,
          dashboardLoaded: this.state.dashboardLoaded===true ? true : count===this.state.totalReportsCount
        }
      );
    } catch (err) {
      console.error(err);
    }
  };

  handleDragStart = (position) => {
    try {
      this.draggingPos.current = position;
      setTimeout(() => {
        let reportIdList = [];
        this.state.selectedReports.map((item) => {
          reportIdList.push(item.widgetId);
        });
        let request = {
          ReportId: reportIdList,
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          DashBoardId: this.state.DbId,
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
        };
        Api.widgetPersist(request);
      }, 2000);
    } catch (err) {
      console.error(err);
      this.draggingPos.current = position;
    }
  };

  handleDragEnter = (dashBoardId, position) => {
    try {
      this.dragOverPos.current = position;
      let dbObj = this.state.dashBoardResponseTemp.find(
        (db) => db.dashboardId === dashBoardId
      );
      const newItems = [...dbObj.widgetCols];
      const draggingItem = newItems[this.draggingPos.current];
      if (!draggingItem) return;

      newItems.splice(this.draggingPos.current, 1);
      newItems.splice(this.dragOverPos.current, 0, draggingItem);

      const reorderedItems = newItems.map((item, index) => ({
        ...item,
        widgetId: item.widgetId,
      }));

      this.draggingPos.current = position;
      this.dragOverPos.current = null;
      let dashboardList = this.state.dashBoardResponseTemp.map((dash) => {
        if (dashBoardId === dash.dashboardId) {
          dash["widgetCols"] = reorderedItems;
        }
        return dash;
      });
      setTimeout(() => {
        this.setState({
          ...this.state,
          dashBoardResponse: dashboardList,
          selectedReports: reorderedItems,
        });
      }, 500);
    } catch (err) {
      console.error(err);
    }
  };

  render() {
    const userId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const value = this.state.value ? this.state.value : [];
    const selected = value.length;
    const { skip, take, selectedReports, isFreezeDS, ...rest } = this.state;
    return (
      <div className="appCont">
        <GenerateReport
          ref="childWidget"
          selectedDB={this.selectDashboard}
          widgetTypeList={this.state.widgetTypeList}
          refreshDashboard={this.refreshDashboard}
          widgetNameLists={this.state.widgetNameLists}
        />

        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}

        {this.state.emailloader ? (
          <span className="MatTableSpinner">
            <MuiThemeProvider theme={theme}>
              <LinearProgress color="secondary" />
            </MuiThemeProvider>
            <span>Downloading Files... </span>
          </span>
        ) : null}

        {/* {this.state.progresspercent < 100 && (
          <div className="progressBar">
            <div className="backdrop"></div>
            <div class="progress">
              <div
                class="progress-bar bg-success progress-bar-striped active progress-bar-animated"
                role="progressbar"
                aria-valuenow="40"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: `${this.state.progresspercent}%` }}
              >
                {this.state.progresspercent}% Completed
              </div>
            </div>
          </div>
        )} */}

        <div className="repCustomCont reportsCont">
          <div
            ref={(node) => {
              this.node = node;
            }}
            className={
              this.state.openSiderBar === true
                ? "reportsSidebar show"
                : "reportsSidebar"
            }
          >
            <div className="repSidebarCont">
              <div className="db">
                <div className="secHeader">
                  <h5>Select Dashboards</h5>

                  <div className="iconCont">
                    <a onClick={this.CreateDashboardOpen} href="#">
                      <img src={Images.ADDGREENICON} width="10" alt="" />
                    </a>
                    <a
                      onClick={() => this.ToggleDashboardReport()}
                      className={
                        this.state.showDashboardList
                          ? "opened arrowIcon"
                          : "arrowIcon"
                      }
                    >
                      <img src={Images.ARROW} width="10" alt="" />
                    </a>
                  </div>
                </div>
                <div className="filterCont">
                  <input
                    type="text"
                    placeholder="Search"
                    value={this.state.dashboardScopeSearch}
                    onChange={(e) => this.searchDashboard(e.target.value)}
                  />

                  <div className="access">
                    <div
                      className="row"
                      style={{ marginRight: "0px", marginLeft: "0px" }}
                    >
                      <label className="riskcheckbox">
                        <Checkbox
                          defaultChecked
                          name="access"
                          value={0}
                          id="private"
                          size="4px"
                          sx={{
                            color: "#009660",
                            "&.Mui-checked": {
                              color: "#009660",
                            },
                          }}
                          onChange={(e) => this.filterDashboardPrivate(e)}
                        />

                        <label for="private">
                          {" "}
                          <img
                            src={Images.LOCK}
                            className="stateIcon"
                            width="20"
                          />
                        </label>
                      </label>
                    </div>
                    &nbsp;&nbsp;&nbsp;
                    <div
                      className="row"
                      style={{ marginRight: "0px", marginLeft: "0px" }}
                    >
                      <label className="riskcheckbox">
                        <Checkbox
                          defaultChecked
                          name="access"
                          value={1}
                          id="public"
                          size="4px"
                          sx={{
                            color: "#009660",
                            "&.Mui-checked": {
                              color: "#009660",
                            },
                          }}
                          onChange={(e) => this.filterDashboardPublic(e)}
                        />
                        {/* <input
                          type="checkbox"
                          name="access"
                          value={1}
                          id="public"
                          defaultChecked="true"
                          onChange={(e) =>
                            this.filterDashboardPublic(e.target.value)
                          }
                        /> */}
                        <label for="public">
                          {" "}
                          <img
                            src={Images.UNLOCK}
                            className="stateIcon"
                            width="20"
                          />
                        </label>
                      </label>
                    </div>
                  </div>
                </div>
                {this.state.showDashboardList ? (
                  <div className="DashboardConts">
                    <ul className="listView">
                      {this.state.dashBoardResponse &&
                        this.state.dashBoardResponse.map((data, index) => (
                          <li
                            className={
                              data.dashboardId === this.state.DbId
                                ? "active"
                                : ""
                            }
                          >
                            <div
                              className="dbLists"
                              style={{ cursor: "default" }}
                            >
                              <span className="statusIcon">
                                <img
                                  src={
                                    data.scope === 0
                                      ? Images.LOCK
                                      : Images.UNLOCK
                                  }
                                  className="stateIcon"
                                  width="20"
                                />
                              </span>
                              <h5
                                style={{ width: "100%" }}
                                onClick={() =>
                                  this.selectDashboard(data.dashboardId)
                                }
                                title={data.name}
                              >
                                {data.name}
                              </h5>
                              {this.isTenentAdmin &&
                              userId !== data.createdBy ? (
                                <div className="dbListIcons">
                                  <a
                                    className="iconG textIcon"
                                    title="Edit"
                                    href="#"
                                    data-toggle="model"
                                    data-target="#openpopup"
                                  >
                                    <ul className="WidgetActions">
                                      <DashboardTextNarrative
                                        chartInputs={data}
                                        selectedDB={this.selectDashboard}
                                        isFreezeDS={false}
                                      />
                                    </ul>
                                  </a>
                                  <a
                                    className="iconR"
                                    title="delete"
                                    onClick={() => this.deleteDashBoard(data)}
                                    href="#"
                                  >
                                    <img
                                      src={Images.TRASH}
                                      width="10"
                                      alt="delete"
                                    />
                                  </a>
                                </div>
                              ) : (
                                <div className="dbListIconsBlock">
                                  {userId === data.createdBy &&
                                  secureLocalStorage.getItem("role") !==
                                    "View Only" &&
                                  secureLocalStorage.getItem("role") !==
                                    "Standard User" ? (
                                    <div className="dbListIcons">
                                      <a
                                        className="iconG textIcon"
                                        title="Edit"
                                        href="#"
                                        data-toggle="model"
                                        data-target="#openpopup"
                                      >
                                        <ul className="WidgetActions">
                                          <DashboardTextNarrative
                                            chartInputs={data}
                                            selectedDB={this.selectDashboard}
                                            isFreezeDS={false}
                                          />
                                        </ul>
                                      </a>
                                      <a
                                        className="iconG"
                                        title="Edit"
                                        onClick={() => this.editDashBoard(data)}
                                        href="#"
                                      >
                                        <img
                                          src={Images.EDITICON}
                                          width="10"
                                          alt="edit"
                                        />
                                      </a>
                                      <a
                                        className="iconG"
                                        title="Freeze"
                                        onClick={() =>
                                          this.openFreezePopup(data)
                                        }
                                        href="#"
                                      >
                                        <img
                                          src={Images.BUSINESS}
                                          width="10"
                                          alt="edit"
                                        />
                                      </a>
                                      <a
                                        className="iconR"
                                        title="delete"
                                        onClick={() =>
                                          this.deleteDashBoard(data)
                                        }
                                        href="#"
                                      >
                                        <img
                                          src={Images.TRASH}
                                          width="10"
                                          alt="delete"
                                        />
                                      </a>
                                    </div>
                                  ) : (
                                    <div className="dbListIconsContent">
                                      {userId === data.createdBy &&
                                        data.scope === 0 && (
                                          <div className="dbListIcons">
                                            <a
                                              className="iconG"
                                              title="Edit"
                                              onClick={() =>
                                                this.editDashBoard(data)
                                              }
                                              href="#"
                                            >
                                              <img
                                                src={Images.EDITICON}
                                                width="10"
                                                alt="edit"
                                              />
                                            </a>
                                            <a
                                              className="iconG"
                                              title="Freeze"
                                              onClick={() =>
                                                this.openFreezePopup(data)
                                              }
                                              href="#"
                                            >
                                              <img
                                                src={Images.BUSINESS}
                                                width="10"
                                                alt="edit"
                                              />
                                            </a>
                                            <a
                                              className="iconR"
                                              title="delete"
                                              onClick={() =>
                                                this.deleteDashBoard(data)
                                              }
                                              href="#"
                                            >
                                              <img
                                                src={Images.TRASH}
                                                width="10"
                                                alt="delete"
                                              />
                                            </a>
                                          </div>
                                        )}
                                    </div>
                                  )}
                                </div>
                              )}

                              {/*  */}
                            </div>

                            <div
                              className={
                                data.dashboardId === this.state.DbId
                                  ? this.state.showDbChartList === true
                                    ? "wl"
                                    : "active wl"
                                  : data.dashboardId === this.state.OtherDbId
                                  ? this.state.showDbOtherChartList === true
                                    ? "wl "
                                    : "active wl"
                                  : "wl"
                              }
                            >
                              <div className="widgetListsCont">
                                {data.widgetCols &&
                                  data.widgetCols.map((widget, index) => (
                                    <div className="widgetLists">
                                      <div
                                        // onClick={() =>
                                        // this.selectedWidgets(widget)
                                        // }
                                        key={widget.widgetId}
                                        draggable
                                        onDragStart={() =>
                                          this.handleDragStart(index)
                                        }
                                        onDragEnter={() =>
                                          this.handleDragEnter(
                                            data.dashboardId,
                                            index
                                          )
                                        }
                                        onDragOver={(e) => e.preventDefault()}
                                        className="resizable"
                                        // className={
                                        //   widget.widgetId ===
                                        //   this.state.WidgetsId
                                        //     ? "active"
                                        //     : ""
                                        // }
                                      >
                                        <div
                                          className="wbox"
                                          title={widget.name}
                                          // title={widget.widgetId}
                                        >
                                          <img
                                            draggable={false}
                                            src={this.getChatImage(
                                              widget.widgetTypeName
                                            )}
                                            width="16"
                                          />
                                          <label draggable={false}>
                                            {widget.name}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {/* Freeze */}

              <div className="qdReports">
                <div className="secHeader pointer">
                  <h5>Select Frozen Dashboards</h5>
                  <div className="iconCont">
                    <a
                      onClick={() => this.ToggleFreezeDashboardReport()}
                      className={
                        this.state.showFreezeReportList
                          ? "opened arrowIcon"
                          : "arrowIcon"
                      }
                    >
                      <img src={Images.ARROW} width="10" alt="" />
                    </a>
                  </div>
                </div>

                {this.state.showFreezeReportList ? (
                  <div>
                    <div className="viewConts">
                      <div className="listView">
                        <ul>
                          {this.state.freezeDashboardList &&
                            this.state.freezeDashboardList.map(
                              (data, index) => {
                                return (
                                  <li
                                    className={
                                      data.dashboardId ===
                                      this.state.ActiveViews
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <div
                                      class="dbLists"
                                      style={{ cursor: "default" }}
                                    >
                                      <h5
                                        className="qname"
                                        style={{
                                          cursor: "pointer",
                                          width: "150px",
                                        }}
                                        onClick={() =>
                                          this.openFreezeReport(data)
                                        }
                                      >
                                        {data.name}
                                      </h5>
                                      {this.isTenentAdmin &&
                                      userId !== data.createdBy ? (
                                        <div className="dbListIcons">
                                          <a
                                            className="iconR"
                                            title="delete"
                                            onClick={() =>
                                              this.openDeleteFreezeDashBoard(
                                                data
                                              )
                                            }
                                            href="#"
                                          >
                                            <img
                                              src={Images.TRASH}
                                              width="10"
                                              alt="delete"
                                            />
                                          </a>
                                        </div>
                                      ) : (
                                        <div className="dbListIconsBlock">
                                          {userId == data.createdBy && (
                                            <div className="dbListIcons">
                                              <a
                                                href="#"
                                                class="iconR"
                                                onClick={() =>
                                                  this.openEditFreezeDashboardPopup(
                                                    data
                                                  )
                                                }
                                              >
                                                <img
                                                  src={Images.EDITICON}
                                                  className="stateIcon"
                                                  width="10"
                                                  alt=""
                                                />
                                              </a>
                                              <a
                                                className="iconR"
                                                title="delete"
                                                onClick={() =>
                                                  this.openDeleteFreezeDashBoard(
                                                    data
                                                  )
                                                }
                                                href="#"
                                              >
                                                <img
                                                  src={Images.TRASH}
                                                  width="10"
                                                  alt="delete"
                                                />
                                              </a>
                                            </div>
                                            //
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </li>
                                );
                              }
                            )}
                        </ul>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>

              {/* End */}

              {/* Risk dataset */}
              <div className="viewsCont rskDataset">
                <div
                  style={{ cursor: "pointer" }}
                  className="secHeader pointer"
                  onClick={() => this.openWidget("RISK")}
                >
                  <h5>Add Risk Report</h5>
                  <div className="iconCont">
                    <a
                      className="iconG"
                      title="Create Risk Report"
                      onClick={() => this.openWidget("RISK")}
                    >
                      <img src={Images.DASHBOARDICON} width="10" alt="" />
                    </a>
                  </div>
                </div>
              </div>
              {/* End  */}
              {/* Action dataset  */}
              <div className="qdReports viewsCont">
                <div
                  style={{ cursor: "pointer" }}
                  className="secHeader pointer"
                  onClick={() => this.openWidget("MITI")}
                >
                  <h5>Add Action Report</h5>
                  <div className="iconCont">
                    <a
                      className="iconG"
                      title="Create Action Report"
                      onClick={() => this.openWidget("MITI")}
                    >
                      <img src={Images.DASHBOARDICON} width="10" alt="" />
                    </a>
                  </div>
                </div>
              </div>
              {/* End  */}

              {/* Task dataset  */}
              {secureLocalStorage.getItem("isTasksModuleEnabled") === true ? (
                <div className="qdReports viewsCont">
                  <div
                    style={{ cursor: "pointer" }}
                    className="secHeader pointer"
                    onClick={() => this.openWidget("TASK")}
                  >
                    <h5>Add Task Report</h5>
                    <div className="iconCont">
                      <a
                        className="iconG"
                        title="Create Task Report"
                        onClick={() => this.openWidget("TASK")}
                      >
                        <img src={Images.DASHBOARDICON} width="10" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {/* End  */}

              {/* Activities dataset  */}
              {secureLocalStorage.getItem("isTasksModuleEnabled") === true ? (
                <div className="qdReports viewsCont">
                  <div
                    style={{ cursor: "pointer" }}
                    className="secHeader pointer"
                    onClick={() => this.openWidget("ACTIVITIES")}
                  >
                    <h5>Add Activities Report</h5>
                    <div className="iconCont">
                      <a
                        className="iconG"
                        title="Create Activity Report"
                        onClick={() => this.openWidget("ACTIVITIES")}
                      >
                        <img src={Images.DASHBOARDICON} width="10" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {/* End  */}
            </div>
          </div>

          <div className="mainWrapper">
            <a
              class="sidebarNavIcon"
              onClick={() => this.openSidebar(this.state.openSiderBar)}
              href="#"
            >
              <img src={Images.SETTINGS} width="18" alt="Stream" />
            </a>

            <div className="downloadPDFBtn">
            {
              this.state.dashboardLoaded===true&&(
              <button onClick={this.generatePdf}>PDF Download</button>
              )
            }
            </div>

            <div className="dashboardCont">
              <div className="widgetContainer">
                <div className="wGridCont reportCont">
                  {selectedReports.map((item) => (
                    <div
                      className={
                        this.handleWidgetFullView(
                          this.state.expandWidgetId,
                          item.widgetId
                        )
                          ? "fullWidth wBox"
                          : "wBox"
                      }
                    >
                      <div className="wGrid" key={item.widgetId}>
                        <div className="wGBox">
                          <div className="wgHeader">
                            <h4
                              title={
                                item.description
                                  ? item.description
                                  : "Description not available"
                              }
                            >
                              {item.widgetTypeName === "HEATMAP" &&
                              item.chartData
                                ? item.chartData.widgetName
                                : item.name}
                            </h4>
                          </div>
                          <div className="chartCont">
                            {this.getReportComponenets(item)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  {isFreezeDS === true ? (
                    <Sortable
                      idField={"widgetId"}
                      disabledField={"disabled"}
                      data={this.setChartDataToState()}
                      emptyItemUI={(props) => <p></p>}
                      itemUI={(props) => (
                        <SortableWidgetUI
                          {...props}
                          onSetWidgetId={this.handleSetWidgetId}
                          refreshTextWidget={this.refreshTextWidget}
                          expandWidgetId={this.state.expandWidgetId}
                          selectedDB={this.getDashboard}
                          selectedDashboard={this.state.selectedDashboard}
                          dashBoardId={this.state.DbId}
                          isFreezeDS={this.state.isFreezeDS}
                          isTenentAdmin={this.isTenentAdmin}
                          showTableFromDashboard={
                            this.state.showTableFromDashboard
                          }
                          HeatMapConfigDataOpportunity={
                            this.state.HeatMapConfigDataOpportunity
                          }
                          HeatMapConfigDataThreat={
                            this.state.HeatMapConfigDataThreat
                          }
                          dynamicHeatmapProbabilityRange={
                            this.state.dynamicHeatmapProbabilityRange
                          }
                          customFieldsmaster={this.state.customFieldsmaster}
                          refreshTextNarative={this.refreshTextNarative}
                        />
                      )}
                      onDragEnd={this.onDragEnd}
                      // onDragOver={this.onDragOver}
                    />
                  ) : (
                    ""
                  )}
                  {/* {this.isFirstApiCallCompleted == true && (
                    <h1 className="loadingRemainingReport">
                      Loading Remaining Reports
                      <span class="dot-one"> .</span>
                      <span class="dot-two"> .</span>
                      <span class="dot-three"> .</span>
                    </h1>
                  )} */}
                </div>
              </div>
            </div>
          </div>

          <Popup show={this.state.showAddToCart} popupClass={"popup-content"}>
            <AddToCart
              {...this.props}
              closeAddToCart={() => this.closeAddToCart()}
              cartViewDetailsId={this.state.cartViewDetails.id}
              cartViewType={this.state.cartViewType}
            />
          </Popup>

          <Dashboard
            {...this.props}
            openCreateDashboard={this.state.openCreateDashboard}
            CreateDashboardClose={this.CreateDashboardClose}
            saveDashboard={this.saveDashboard}
            updateDashboard={this.updateDashboard}
            editFlag={this.state.editFlag}
            loader={this.state.loader}
            userList={this.state.userList}
            editDashBoardData={this.state.editDashBoardData}
            ref="dashboardChild"
          />

          <Popup
            show={this.state.openFreezeModelFlagView}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}

            <form name="dashboardname">
              <div className="createDashboardDialog">
                <h4>
                  {this.state.enablefreezedashborad
                    ? // this.state.editFlag
                      "Update freeze Dashboard"
                    : "Create freeze Dashboard"}
                </h4>
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-10">
                    <div className="formControl">
                      <label> Name</label>
                      <input
                        type="text"
                        value={this.state.freezeName}
                        onBlur={(e) => {
                          this.setState({
                            freezeName: e.target.value,
                          });
                        }}
                        onChange={(e) => {
                          this.setState({
                            freezeName: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="accessSpecifier">
                  <RadioGroup
                    aria-label="gender"
                    name="gender1"
                    value={this.state.scope}
                    onChange={(e) =>
                      this.setState({
                        ...this.state,
                        scope: e.target.value,
                      })
                    }
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="Shared"
                    />

                    <FormControlLabel
                      value="0"
                      control={<Radio />}
                      label="Private"
                    />
                  </RadioGroup>
                </div>

                {this.state.scope === "1" && (
                  <div>
                    <p>Select Users:</p>
                    <MultiSelect
                      data={this.state.userList.filter(
                        (item) => !item.isSuperAdmin && !item.isTenantAdmin
                      )}
                      itemRender={this.itemRender}
                      autoClose={false}
                      value={value}
                      onChange={this.handleChange}
                      textField="displayName"
                      dataItemKey="userId"
                      tags={
                        selected > 0
                          ? [
                              {
                                text: `${selected} users selected`,
                                data: [...value],
                              },
                            ]
                          : []
                      }
                    />
                  </div>
                )}
                <div className="btnCont">
                  {this.state.freezeEditMode ? (
                    <button
                      className="btnGreen"
                      type="button"
                      // disabled={!this.state.name}
                      onClick={this.updateFrozenDashboard}
                    >
                      Update
                    </button>
                  ) : (
                    <button
                      className="btnGreen"
                      type="button"
                      // disabled={!this.state.name}
                      onClick={this.freezeDashboard}
                    >
                      Submit
                    </button>
                  )}

                  <button
                    className="btnRed"
                    type="button"
                    onClick={this.closeFreezePopup}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </Popup>

          <Popup
            show={this.state.openDeleteFreezeModelFlag}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this frozen dashboard?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeFreezeDashBoard()}
                  className="deleteBtn"
                  type="button"
                >
                  Delete
                </button>
                <button
                  onClick={this.closeDeleteFreezeDashBoard}
                  className="cancelBtn"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </Popup>

          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>
                Are you sure you want to delete this dashboard? This will delete
                all reports
              </h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeDashboard()}
                  className="deleteBtn"
                >
                  Yes
                </button>
                <button
                  onClick={this.deleteDashboardPopupClose}
                  className="cancelBtn"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      </div>
    );
  }
}
